import { collection, getDocs, query, where } from "firebase/firestore";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Failure from "../../../core/Failure";
import { IContact } from "@leedpulse-monorepo/interfaces";

async function getContactsByOwner(owner: string): Promise<IContact[] | null> {
  try {
    const db = firestore;
    const contactsCollection = collection(db, FirestoreCollections.contacts);

    const results = await getDocs(
      query(
        contactsCollection,
        where('contact.owner', '==', owner)
      )
    );

    const contacts: IContact[] = [];
    results.docs.forEach((doc) => {
      contacts.push(doc.data() as IContact);
    });

    return contacts;
  } catch (e) {
    console.log("error: ", e);
    throw new GetContactsByOwnerFailure();
  }
}

export class GetContactsByOwnerFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getContactsByOwner;
